import { X } from 'lucide-react';
import { useRecoilState } from 'recoil';

import { DashboardReferenceChip } from '@/components/chat/DashboardReferenceChip';
import { dashboardReferencesState } from '@/state/chat';

export function DashboardReferences() {
    const [references, setReferences] = useRecoilState(
        dashboardReferencesState
    );

    return (
        <div className="flex flex-wrap gap-2">
            {references.map((reference) => (
                <div
                    key={reference.id}
                    className="group relative"
                >
                    <button
                        type="button"
                        aria-label="Remove reference"
                        onClick={() =>
                            setReferences((current) =>
                                current.filter(
                                    (item) => item.id !== reference.id
                                )
                            )
                        }
                        className="top-1 right-1 absolute opacity-0 group-hover:opacity-100 focus-visible:opacity-100 text-muted-foreground hover:text-foreground"
                    >
                        <X className="w-3.5 h-3.5" />
                    </button>
                    <DashboardReferenceChip chip={reference} />
                </div>
            ))}
        </div>
    );
}
